export const PROPERTY_SANDBOX_SETTLEMENT_BATCHES = "sandbox.settlementBatches";
export const PROPERTY_PRODUCTION_SETTLEMENT_BATCHES =
  "production.settlementBatches";

export type TriggerSettlementCode =
  | "creatingSettlementInitiated"
  | "noUnsettledOperations";
